export default __webpack_public_path__ + "static/media/mobile-map-en.0bb5591e.svg";